<template>
	<div class="user-stats" v-if="stats">
		<div class="stat-card">
			<span class="stat-value">{{ stats.premiumCount }}</span>
			<span class="stat-label">Premium Users</span>
		</div>
		<div class="stat-card">
			<span class="stat-value">{{ stats.trialCount }}</span>
			<span class="stat-label">Free Trial Users</span>
			<span class="stat-hint">Signed up in the last 30 days, not subscribed</span>
		</div>
		<div class="stat-card">
			<span class="stat-value">{{ stats.totalUsers }}</span>
			<span class="stat-label">Total Users</span>
		</div>
	</div>
</template>

<script>
import SolFileAPIInstance from '@/api'

export default {
	name: "UserStatsCards",
	data() {
		return {
			stats: null
		}
	},
	async mounted() {
		const response = await SolFileAPIInstance.getUserStats()
		if (response && response.data && response.data.data) {
			this.stats = response.data.data
		}
	}
}
</script>

<style lang="scss" scoped>
.user-stats {
	display: flex;
	flex-wrap: wrap;
	gap: 15px;
	margin-bottom: 20px;
}

.stat-card {
	display: flex;
	flex-direction: column;
	flex: 1;
	min-width: 180px;
	background-color: #fff;
	border-radius: 6px;
	padding: 15px 20px;
}

.stat-value {
	font-size: 2rem;
	font-weight: 700;
	color: #34558b;
	line-height: 1.2;
}

.stat-label {
	font-weight: 600;
	color: #35495e;
}

.stat-hint {
	font-size: 0.75rem;
	color: #7d8ea3;
}
</style>
